import { Account, AccountOnboarding } from '@adtrackify/at-tracking-event-types';
import { QueryClient } from '@tanstack/react-query';

import { accountKeys } from '@/features/workspace/api/account-keys';
import type {
  AccountsCacheEntry,
} from '../types/onboarding-cache-update-types';

export function applyOnboardingToAccountsCache(
  queryClient: QueryClient,
  accountId: string,
  onboarding: Partial<AccountOnboarding>
): AccountsCacheEntry | undefined {
  const previous = queryClient.getQueryData<AccountsCacheEntry>(accountKeys.list());
  if (!previous?.data?.accounts) {
    return previous;
  }

  queryClient.setQueryData<AccountsCacheEntry>(accountKeys.list(), {
    ...previous,
    data: {
      ...previous.data,
      accounts: previous.data.accounts.map((account: Account) =>
        account.id === accountId
          ? { ...account, onboarding: { ...account.onboarding, ...onboarding } }
          : account
      ),
    },
  });

  return previous;
}

export function restoreAccountsCache(
  queryClient: QueryClient,
  previous: AccountsCacheEntry | undefined
): void {
  if (!previous) {
    return;
  }
  queryClient.setQueryData<AccountsCacheEntry>(accountKeys.list(), previous);
}
